/* eslint-disable */

import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { MarkerClusterer, DefaultRenderer } from '@googlemaps/markerclusterer';  // Use MarkerClusterer v2.x

// operations for the map, set in the craft templates eg: online-collections/types/oralHistoriesLanding etc
const operations = window.operations;
console.log(operations);
// Coordinates and zoom set in craft templates
const startLat = window.startLat;
const startLong = window.startLong;
const zoom = window.zoom;
let lazySettings = window.lazy_settings;
let featuredSettings = {};
featuredSettings['templatePath'] = 'online-collections/types/featured-operations/operation.twig';
featuredSettings['variableName'] = 'operation';
featuredSettings['section'] = 'operations';

let featuredBrigadeSettings = {};
featuredBrigadeSettings['templatePath'] = 'online-collections/types/featured-brigades/brigade.twig';
featuredBrigadeSettings['variableName'] = 'brigade';
featuredBrigadeSettings['section'] = 'brigades';

var county = '';
var operation = '';
var title = '';
var civilwar = true;
let ajaxTable = document.querySelector('.operationsTable');
let featuredContainer = document.querySelector('.featuredContainer');
let loadMoreButton = document.querySelector('.js-load-more');
let featuredBrigadesContainer = document.querySelector('.featuredBrigadesContainer');
let currentRequest = null,
    notAllDisplayed = true;
let lazyOffset = 1;

const ready = (func) => {
  if (document.readyState !== 'loading') {
      func();
  } else {
      document.addEventListener('DOMContentLoaded', func);
  }
};

console.log(lazySettings);

setOptions({
  // Military archives google API key
  key: "AIzaSyCHYhJW-qzt0jzzBm0LRhvnsGUknmzNEEE",
  v: "weekly",
  libraries: ['marker']  // Keep 'marker' library for handling markers
});

// Custom Renderer for cluster icons
class CustomClusterRenderer extends DefaultRenderer {
  render({ count, position }) {

    // Colours for different cluster sizes
    let color;
    if (count < 10) {
      color = '#191919'; 
    } else if (count < 50) {
      color = '#191919'; 
    } else {
      color = '#191919';
    }

    // Create a custom SVG icon with the selected color
    const svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <circle cx="20" cy="20" r="20" fill="${color}" />
        <text x="20" y="25" text-anchor="middle" font-size="12" font-family="Arial" fill="white">${count}</text>
      </svg>
    `);

    // Return a custom cluster icon with the colored SVG
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(40, 40),  // Size of the icon
      },
      label: {
        text: String(count),  // Number of markers in the cluster
        color: 'white',       // Color of the text inside the cluster
        fontSize: '12px',     // Text font size
      },
      zIndex: google.maps.Marker.MAX_ZINDEX + count,  // Ensure clusters appear on top
    });
  }
}

// Load the Maps API
const mapOptions = {
  center: { lat: startLat, lng: startLong },
  zoom: zoom,
  mapId: 'a18a7ca9a3d91770',
  disableDefaultUI: true,
  zoomControl: true
};

importLibrary('maps').then(({ Map }) => {
    const map = new Map(document.getElementById("operationmap"), mapOptions);
    
    //The map pin is generated as svg, color, shape and scale set here
    const mapPin = {
        path: 'M7 0C3.13 0 0 3.13 0 7C0 8.74 0.5 10.37 1.41 11.84C2.36 13.38 3.61 14.7 4.57 16.24C5.04 16.99 5.38 17.69 5.74 18.5C6 19.05 6.21 20 7 20C7.79 20 8 19.05 8.25 18.5C8.62 17.69 8.95 16.99 9.42 16.24C10.38 14.71 11.63 13.39 12.58 11.84C13.5 10.37 14 8.74 14 7C14 3.13 10.87 0 7 0ZM7 9.75C5.62 9.75 4.5 8.63 4.5 7.25C4.5 5.87 5.62 4.75 7 4.75C8.38 4.75 9.5 5.87 9.5 7.25C9.5 8.63 8.38 9.75 7 9.75Z',
        strokeColor: '#191919',
        fillColor: '#191919',
        fillOpacity: 1,
        scale: 1.1,
    };

    let markerCluster = null;
    let refreshMarkerCluster = null;
    let markers = [];
    const bounds = new google.maps.LatLngBounds(); // Create LatLngBounds object

    //The code

    $(".county-dropdown").on("change", function() {
      county = $(this).val();
      filterMarkers(civilwar, county);
      filterTable(civilwar, county);
      filterFeatured(civilwar, county);
      filterFeaturedBrigades(county);
      $('.county-dropdown').val(county);
    });

    $(".civilwar").on("change", function() {
      var isChecked = $(this).is(':checked');
      $('.civilwar').prop('checked', isChecked);
      if ($(this).is(':checked')) {
        civilwar = true;
      } else {
        civilwar = false;
      }
      filterMarkers(civilwar, county);
      filterTable(civilwar, county);
      filterFeatured(civilwar, county);
    });

    $("#operation").keyup(function() {
      title = $(this).val();
      console.log(title);      
      filterTable(civilwar, county, title);
      
    });
    
    function filterMarkers(civilwar, county) {
      const updatedOperations = [];
      $.ajax({
        url: '/map-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,   
          civilwar: civilwar,
          settings: lazySettings
        }, // Pass the selected filter
        success: function(response) {
          // Assuming the server returns a list of operations similar to the initial `operations`

          clearMarkersAndClusters();

          response.data.forEach(item => {
            //console.log(item.title);  // Outputs each title to the console
    
          });
          
          response.data.forEach(item => {

            console.log(item.title);
            console.log(item.latitude);

            if (item.latitude > 0) {
    
            const info = '<div class="map-info-block"><a href="' + item.url + '"><h3>' + item.title + '</h3></a><p><strong>Location:</strong> ' + item.location + '<br /><strong>County:</strong> ' + item.county + '<br /><strong>Date:</strong> ' + item.date + '</p></div><a href="' + item.url + '">View operation</a>';
    
            updatedOperations.push({
              position: {
                lat: item.latitude,
                lng: item.longitude
              },
              label: item.title,
              title: item.title,
              url: item.url,
              info: info
            });

            }

          });
    
          updateMarkers(updatedOperations);              
    
          //updateMarkers(response.operations); // Update markers based on the response
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function filterTable(civilwar, county, title) {
      lazyOffset = 1;
      notAllDisplayed = true;
      

      $.ajax({
        url: '/table-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,   
          civilwar: civilwar,
          title: title,
          settings: lazySettings,   
        }, // Pass the selected filter
        success: function(response) {
          ajaxTable.innerHTML = "";
          let table = '';
          response.data.forEach(item => {
            table += item.html;
          });
          ajaxTable.innerHTML += table;
          if (loadMoreButton) {
            loadMoreButton.style.display = 'block';
          }
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function filterFeatured(civilwar, county) {
      if (!featuredContainer) {
        return;
      }
      $.ajax({
        url: '/featured-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,   
          civilwar: civilwar,          
          settings: featuredSettings,   
        }, // Pass the selected filter
        success: function(response) {
          featuredContainer.innerHTML = "";
          let list = '';
          response.data.forEach(item => {
            list += item.html;
          });
          featuredContainer.innerHTML += list;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function filterFeaturedBrigades(county) {
      if (!featuredBrigadesContainer) {
        return;
      }
      $.ajax({
        url: '/featured-brigades-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          county: county,            
          settings: featuredBrigadeSettings,   
        }, // Pass the selected filter
        success: function(response) {
          featuredBrigadesContainer.innerHTML = "";
          let list = '';
          response.data.forEach(item => {
            list += item.html;
          });
          featuredBrigadesContainer.innerHTML += list;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

        function initiateFeaturedBrigades() {
      if (!featuredBrigadesContainer) {
        return;
      }
      $.ajax({
        url: '/featured-brigades-initiate',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {          
          settings: featuredBrigadeSettings,   
        }, // Pass the selected filter
        success: function(response) {
          featuredBrigadesContainer.innerHTML = "";
          let list = '';
          response.data.forEach(item => {
            list += item.html;
          });
          featuredBrigadesContainer.innerHTML += list;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });
    }

    function clearMarkersAndClusters() {
      // Clear each marker by setting its map to null

      markers.forEach(marker => marker.setMap(null));

      // Clear the markers array
      markers = [];

      // If a MarkerClusterer instance exists, clear the clusters and markers
      if (refreshMarkerCluster) {

        refreshMarkerCluster.setMap(null);
        refreshMarkerCluster.clearMarkers();
          // Clear the clusters
        refreshMarkerCluster = null;  // Reset the markerCluster instance
      } 
      if (markerCluster) {

        markerCluster.setMap(null);
        markerCluster.clearMarkers();  // Clear the clusters
          // Clear the clusters
        markerCluster = null;  // Reset the markerCluster instance
      }  else {

      }
    } 

    var oldValue = 0
    var newValue = 0

    ready(() => {


      $(".js-load-more").click(function() {
          
          if (currentRequest === null && notAllDisplayed === true) {

              loadMoreButton.style.display = 'block';              

              currentRequest = $.ajax({
                  url: '/table-load-more',
                  method: 'GET',
                  data: {
                      offset: lazyOffset,
                      county: county,   
                      civilwar: civilwar,
                      settings: lazySettings,  
                  },
                  beforeSend: () => {
                      //lazyPreloader.style.display = 'block';
                  },
              })
              .always(() => {
                  //lazyPreloader.style.display = 'none';
                  currentRequest = null;
              })
              .done((returned) => {
                  lazyOffset++;
                  let html = '';
                  returned.data.forEach((element) => {                                            
                      html += element.html;
                  });        
                  ajaxTable.innerHTML += html;
                  if (!returned.data.length) {
                      notAllDisplayed = false;
                      loadMoreButton.style.display = 'none';
                  }
                  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                      return new bootstrap.Tooltip(tooltipTriggerEl)
                  })
              })
              .fail(() => {
                  errorMessage.textContent = 'Unable to retrieve articles.';
              });
          }
          //oldValue = newValue;

        });
    });

    function updateTable(operations) {
      // Pages without a Load More button (e.g. the brigade entry page) render a
      // fixed, already-correctly-scoped table server-side; /table-filter has no
      // way to filter by brigade, so skip the ajax refresh that would overwrite it.
      if (!loadMoreButton) {
        return;
      }
      lazyOffset = 1;
      notAllDisplayed = true;
      loadMoreButton.style.display = 'block';
      $.ajax({
        url: '/table-filter',  // The server endpoint to fetch filtered data
        type: 'GET',
        data: {
          settings: lazySettings,   
        }, // Pass the selected filter
        success: function(response) {
          ajaxTable.innerHTML = "";
          let table = '';
          response.data.forEach(item => {
            table += item.html;
          });
          ajaxTable.innerHTML += table;
        },
        error: function(error) {
          console.log("Error fetching filtered data:", error);
        }
      });

    };

    function updateMarkers(operations) {

      console.log('updating');

      //markers = [];  // Reset the markers array         
      refreshMarkerCluster = new MarkerClusterer({
        map: map,
        markers: markers,
        renderer: new CustomClusterRenderer()
      });
    
      const bounds = new google.maps.LatLngBounds(); // Reset bounds
    
      // Iterate through each operation and create a new marker
      operations.forEach(operation => {
        const marker = new google.maps.Marker({
          position: operation.position,
          title: operation.title,
          icon: mapPin
        });
    
        markers.push(marker);  // Add new marker to the array
        bounds.extend(marker.getPosition());  // Extend bounds to include marker position
    
        // InfoWindow for each marker
        marker.addListener('click', () => {
          const popup = document.getElementById("custom-popup");
          document.getElementById("popup-content").innerHTML = operation.info;
          popup.style.display = "block";
          scrollIntoViewIfNotVisible(popup);
        });
      });
    
      // Fit the map to the new bounds that include all markers
      map.fitBounds(bounds);
    
      // Reinitialize MarkerClusterer with the updated markers
      refreshMarkerCluster = new MarkerClusterer({
        map: map,
        markers: markers,
        renderer: new CustomClusterRenderer()
      });
      //refreshMarkerCluster();
    }   


    updateMarkers(operations);
    updateTable(operations);
    filterFeatured();
    initiateFeaturedBrigades();
    //filterFeaturedBrigades();
    //updateTable(operations);
});


$("#map-close-btn").on("click", function() {

  document.getElementById("custom-popup").style.display = "none";
});

function scrollIntoViewIfNotVisible(target) {   
  if (target.getBoundingClientRect().top < 70) {
      target.scrollIntoView();
      scrollToTargetAdjusted(target);
  } 
}

function scrollToTargetAdjusted(element){
  var headerOffset = 137;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
  });
}

/* eslint-enable */